import { gql } from "@apollo/client";

const GET_REMITTANCES_WITH_INCOMPLETE_DEDUCTIONS = gql`
  query GetRemittancesWithIncompleteDeductions($params: GetRemittanceWithIncompleteDeductionsParams!) {
    remittancesWithIncompleteDeductions(params: $params) {
      total
      columns {
        key
        title
      }
      page
      limit
      items {
        isNew
        checkNo
        checkDate
        checkAmount
        deductedAmount
        purchaser {
          purchaserId
          purchaserName
          purchaserKey
        }
        remittanceId
        remittanceItems {
          checkNo
          invoiceNo
          invoiceDate
          age
          grossAmount
          netAmount
          discountAmount
          purchaser {
            purchaserId
            purchaserName
            purchaserKey
          }
          remittanceId
          remittanceItemId
          description
          isDeduction
          isBackupRequested
          canRequestBackup
        }
      }
    }
  }
`;

export default GET_REMITTANCES_WITH_INCOMPLETE_DEDUCTIONS;
